import { render } from "./InfoBox.vue?vue&type=template&id=00b0fa3e&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=ts"
export * from "./InfoBox.vue?vue&type=script&lang=ts"

import "./InfoBox.vue?vue&type=style&index=0&id=00b0fa3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00b0fa3e"

export default script